import todoTypes from "../../../../constants/todoTypes";

import getOfferProductionManagers from "../../helpers/team/managers/getOfferProductionManagers";

import createTodoData from "../todos/createTodoData";

export default function createOfferStatusChangedTodoData(firebase, { offer, status }) {
	const productionManagers = getOfferProductionManagers({ offer });

	return createTodoData(firebase, {
		type: todoTypes.OFFER_STATUS_CHANGED,
		organizationIds: [offer.producer.id],
		userIds: productionManagers.map((pM) => pM.id),
		users: productionManagers,
		subjectRef: offer.ref,
		url: `/production/${offer.production?.id}/team`,
		notification: true,
		languages: [offer.production.language],
		content: {
			offer: {
				status,
				type: offer.type,
				role: offer.role,
				id: offer.id,
			},
			secondParty: {
				id: offer.secondParty.id,
				name: offer.secondParty.name,
			},
			production: {
				title: offer?.production?.title,
				id: offer?.production.id,
			},
			publisher: {
				id: offer?.publisher?.id,
				name: offer?.publisher?.name,
			},
		},
	});
}
